import { ETABLISSEMENT_STATUT_FICHIER_TEXTS } from './texts';
import { SuiviDepotFilters } from './types/suivi-depot-filter.type';

export const SUIVI_DEPOT_DEFAULT_FILTERS: SuiviDepotFilters = {
  search: '',
  statutDeclaration: null,
  statutAttestation: null,
};

export const SUIVI_DEPOT_FILTERS_TEXTS: Record<keyof SuiviDepotFilters, string> = {
  search: 'Recherche',
  statutDeclaration: 'Statut de la déclaration',
  statutAttestation: 'Statut de l\'attestation',
};

const statutFormatter = (statut) => ETABLISSEMENT_STATUT_FICHIER_TEXTS[statut];

export const SUIVI_DEPOT_FILTERS_VALUE_MAPPING = {
  statutDeclaration: statutFormatter,
  statutAttestation: statutFormatter,
};